import { jwtKey, localStorageKey, passportTokenKey, userKey } from '@/global';
import axios from 'axios';
import jwt from 'jsonwebtoken';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    userScope: null,
    token: null,
    showCompanySave: null,
    showContractSave: null,
    showPlanSave: null,
    showContractReadjustment: null,
    showContractProductId: null,
    showGroupSave: null,
    showSegmentSave: null,
    showInvoiceSave: null,
    showInvoiceLoose: null,
    authorizedContaAzul: !!localStorage.getItem('authorizedContaAzul'),
    showCustomerSave: null,
    showStatsCustomer: null,
    showOmieSyncLogs: null,
    showOmieEmailSendLogs: null,
    showOmieInvoiceSendLogs: null,
    showSegmentCustomersList: null,
    selectedSegmentName: null,
    showCreateDiscount: null,
    showCompanyDiscount: null,
    showScopeSave: null,
    showUserSave: null,
    showRoleSave: null,
    showPocSave: null,
    showLogError: null,
    showLogContract: null,
    showInvoiceDuplicate: null,
    selectedInvoice: null,
    showCreateBonus: null,
    showCreateDiscountAddition: null,
    showCustomerBonuses: null,
    showCustomerDiscountAdditions: null,
    showInvoiceGenerateCsv: null,
    showCustomerGroupSave: null,
    showProposalSave: null,
    showLogPendingInvoices: null,
    showPendingInvoiceJobLogs: null,
    showLogEmail: null,
    omieAlerts: {
      sync: 0,
      email: 0,
      invoice: 0,
      consumption: 0,
      pending: 0,
    },
  },
  getters: {
    currentUser: (state) => {
      if (!state.user) {
        state.user = localStorage.getItem(userKey);
        state.user = jwt.decode(state.user);
      }
      return state.user;
    },
    currentScope: (state) => {
      if (!state.userScope) {
        state.token = localStorage.getItem(passportTokenKey);
        if (state.token) {
          state.token = jwt.decode(state.token);
          state.userScope = jwt.decode(state.token);
          state.userScope = state.userScope.scopes;
        }
      }
      return state.userScope;
    },
    currentToken: (state) => {
      if (!state.token) {
        state.token = localStorage.getItem(passportTokenKey);
        state.token = jwt.decode(state.token);
      }
      if (state.token) {
        axios.defaults.headers.common.Accept = 'application/json';
        axios.defaults.headers.common.Authorization = `Bearer ${state.token}`;
      } else {
        delete axios.defaults.headers.common.Authorization;
      }
      return state.token;
    },
    currentStorageVersion: (state) => localStorage.getItem(localStorageKey),
  },
  mutations: {
    setUser(state, user) {
      if (user) {
        state.user = user;
        const encodedUser = jwt.sign(user, jwtKey);
        localStorage.setItem(userKey, encodedUser);
      } else {
        state.user = null;
        localStorage.removeItem(userKey);
      }
    },
    setUserScope(state, userScope) {
      state.userScope = userScope || null;
    },
    setToken(state, token) {
      if (token) {
        state.token = token;
        const decodedToken = jwt.decode(token);
        state.userScope = decodedToken.scopes;
        token = jwt.sign(token, jwtKey);
        localStorage.setItem(passportTokenKey, token);
      } else {
        state.token = null;
        localStorage.removeItem(passportTokenKey);
      }
      if (state.token) {
        axios.defaults.headers.common.Accept = 'application/json';
        axios.defaults.headers.common.Authorization = `Bearer ${state.token}`;
      } else {
        delete axios.defaults.headers.common.Authorization;
      }
    },
    setContaAzulAuthorized(state, isAuthorized) {
      if (!isAuthorized) {
        localStorage.removeItem('authorizedContaAzul');
      } else {
        localStorage.setItem('authorizedContaAzul', isAuthorized);
      }
      state.authorizedContaAzul = isAuthorized;
    },
    setLocalStorageVersion(state, version) {
      localStorage.setItem(localStorageKey, version);
    },
    setOmieAlerts(state, alerts) {
      state.omieAlerts = {
        sync: alerts.sync || 0,
        email: alerts.email || 0,
        invoice: alerts.invoice || 0,
        consumption: alerts.consumption || 0,
        pending: alerts.pending || 0,
      };
    },
  },
});
